// @flow
import React from 'react';
import AnimatingProgressBar from 'app/common/react/components/growth/unauth/signup/GoogleOneTap/AnimatingProgressBar';
import i18n from 'app/common/lib/i18n';
import { Box, Heading, Icon, Text } from 'gestalt';

const MIN_MODAL_WIDTH = '500px';

const SignupWelcomeLoading = () => (
  <Box
    alignItems="center"
    display="flex"
    justifyContent="center"
    position="absolute"
    width="100%"
    height="100%"
  >
    <Box color="white" height={600} minWidth={MIN_MODAL_WIDTH} shape="rounded" width="30%">
      <Box
        alignItems="center"
        direction="column"
        display="flex"
        height="99%"
        justifyContent="center"
        padding={12}
      >
        <Box
          alignItems="center"
          color="red"
          display="flex"
          height={60}
          justifyContent="center"
          marginBottom={4}
          shape="circle"
          width={60}
        >
          <Icon
            accessibilityLabel={i18n._('Loading state for google one tap registration')}
            color="white"
            icon="pin"
            size="28"
          />
        </Box>
        {/* Headings don't have a center option, need to add text-align to parent Box */}
        <Box
          alignItems="center"
          paddingY={5}
          dangerouslySetInlineStyle={{ __style: { 'text-align': 'center' } }}
        >
          <Heading size="sm">{i18n._('Welcome to Pinterest!', 'Welcome to Pinterest!')}</Heading>
        </Box>
        <Text size="xl" align="center" overflow="normal">
          {i18n._(
            'Your answers to the next questions will help us find the right ideas for you',
            'loading state description while waiting for google one tap registration to complete',
          )}
        </Text>
      </Box>
      <AnimatingProgressBar duration={6000} finalProgress={95} />
    </Box>
  </Box>
);

export default SignupWelcomeLoading;
